import config from "config";
import apps from "./apps";
import buttonWidget from "./button";
import dashboard from "./dashboard";
import { IMenuItems } from "./MenuModel";
import pricing from "./pricing";
import tikTok from "./tiktok";
export default class MenuManagement {
  public static items = (): IMenuItems[] => {
    let menuItems = [
      dashboard,
      tikTok,
      buttonWidget
    ];
    if(config.enablePricing){
      menuItems.push(pricing);
    }
    menuItems.push(apps);
    return menuItems;
  } 
}
